var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImpersonate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "10px",
    viewBox: "0 0 20 10",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "F8E6037E-86A6-47D5-9660-DDFB0B26ADB4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-KIt",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-552.000000, -190.000000)",
    fill: "#7C809B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M566.629045,190 C564.230055,190 563.421974,191.717172 561.98258,191.868687 C560.543186,191.717172 559.735105,190 557.361368,190 C545.038136,190 557.159348,206.338384 561.98258,195.909091 C566.831065,206.338384 578.927025,190 566.629045,190 Z M554.507833,194.191919 C555.896722,193.106061 559.810863,192.171717 559.810863,194.191919 C559.810863,195.126263 558.97753,195.429293 557.967429,195.378788 L557.740156,196.515152 L557.411873,198.080808 L557.108843,196.515152 L556.831065,195.227273 C555.947227,195 555.038136,194.621212 554.507833,194.191919 Z M564.356318,194.191919 C564.356318,192.171717 568.245206,193.106061 569.634095,194.191919 C569.028035,194.69697 567.916924,195.151515 566.856318,195.328283 L566.654297,196.313131 L566.351267,197.878788 L566.022984,196.313131 L565.846217,195.378788 C564.987631,195.353535 564.356318,195.025253 564.356318,194.191919 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImpersonate);
export default ForwardRef;